module.exports = __webpack_public_path__ + "static/media/login-img.20a90984.svg";